import type { ReactNode } from 'react'
import { Wordmark } from '../Wordmark'

// The first run's screen (IntroPager, PersonalizeFlow): ink in both themes,
// like the splash, through the forced-dark tokens; the wordmark and a bar part
// per step at the top with a quiet Skip, the step in the middle, its button
// at the bottom within the thumb's reach.

export function Frame({ steps, at, onSkip, skipLabel = 'Skip', footer, children, stage }: {
  steps: number
  /** The step showing, from 0. */
  at: number
  onSkip?: () => void
  skipLabel?: string
  footer?: ReactNode
  children: ReactNode
  /** The middle's own props (the intro's swipe). */
  stage?: React.HTMLAttributes<HTMLDivElement> & { style?: React.CSSProperties }
}) {
  return (
    <div className="ml-fr ml-dark-scope">
      <header className="ml-fr__top">
        <Wordmark size={20} />
        {onSkip && <button type="button" className="ml-fr__skip" onClick={onSkip}>{skipLabel}</button>}
      </header>
      {steps > 1 && (
        <div className="ml-fr__bar" aria-hidden="true">
          {Array.from({ length: steps }, (_, i) => <i key={i} className={i <= at ? 'is-on' : undefined} />)}
        </div>
      )}
      <div {...stage} className={`ml-fr__stage${stage?.className ? ` ${stage.className}` : ''}`}>{children}</div>
      {footer && <footer className="ml-fr__foot">{footer}</footer>}
    </div>
  )
}

/** A claim in the wordmark's voice, its last line in the accent. */
export function Claim({ lines, id }: { lines: string[]; id?: string }) {
  return (
    <h1 className="ml-fr__title" id={id}>
      {lines.map((l, i) => (
        <span key={i} className={i === lines.length - 1 ? 'ml-fr__accent' : undefined}>{i > 0 && ' '}{l}</span>
      ))}
    </h1>
  )
}
